import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { Skeleton, Stack } from '@mui/material';

import { Leaderboard } from 'components/Analytics/Leaderboard';
import { ResponseTime } from 'components/Analytics/ResponseTime';
import { TaskSuccessRate } from 'components/Analytics/TaskSuccessRate';

import { useApi } from '../../hooks/useApi';

export const AnalyticsDashboard = () => {
  const { user } = useUser();
  const { apiFetch } = useApi();

  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    if (!user?.id) return;

    (async () => {
      const res = await apiFetch('analytics');
      const data = await res.json();

      setAnalytics(data);
    })();
  }, [user?.id]);

  return analytics ? (
    <>
      <Stack gap={2}>
        <ResponseTime
          avgResponseTime={analytics.avgResponseTime}
          fastestResponseTime={analytics.fastestResponseTime}
          slowestResponseTime={analytics.slowestResponseTime}
        />
        <Stack
          direction="row"
          spacing={4}
        >
          <TaskSuccessRate successRate={analytics.successRate} />
          <Leaderboard leaderboard={analytics.leaderboard} />
        </Stack>
      </Stack>
    </>
  ) : (
    <Skeleton
      variant="rounded"
      width="100%"
      height={200}
    />
  );
};
